/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

/*
$(function() {
  $('.mod-intro-survey .choose-one .button').click(() => (typeof analytics !== 'undefined' && analytics !== null) && analytics.track("Started Intro Survey"));
  return $("a[data-remote]").on("ajax:success", (e, data, status, xhr) => $('.terms-copy').html(data));
});
*/

initIntroSurvey = function() {
  $('.mod-intro-survey .choose-one .button').click(() => (typeof analytics !== 'undefined' && analytics !== null) && analytics.track("Started Intro Survey"));
}
initIntroSurveyTerms = function() {
  $("a[data-remote]").on("ajax:success", function(e) {
    var data = e.originalEvent ? e.originalEvent.detail[0] : e.detail[0];
    $('.terms-copy').html(data);
  });
  $('#show-terms, #show-privacy').on('click', function() {
    var url = $(this).data('terms-url');
    if (url) {
      $.get(url, function(data) { $('.terms-copy').html(data); });
    }
  });
};

function initIntroSurveyOnLoad() {
  if ($('.mod-intro-survey .choose-one .button').length) {
    initIntroSurvey();
  }
  if ($('a[data-remote]').length || $('#show-terms, #show-privacy').length) {
    initIntroSurveyTerms();
  }
}

$(initIntroSurveyOnLoad);
document.addEventListener('turbo:load', initIntroSurveyOnLoad);
